import type { TrainTranslations } from "./trainTranslations.types";

const trainUkTranslations: TrainTranslations = {
    trainPage: {
        title: "Train",
        step: "Step",
        resultsFound: "train options found",
        stopOver: "Stop",
        stopOverPlural: "Stops",
        nextStep: "Next step",
        loadingTimeline: "Loading timetable…",
    },
    trainSortBy: {
        title: "Sort by",
        price_asc: "Lowest price first",
        price_desc: "Highest price first",
        fastest: "Fastest",
        fewest_changes: "Fewest changes"
    },
    trainBlock: {
        title: "Train Service",
        direct: "Direct"
    },
    trainFilters: {
        outboundTrip: {
            title: "Outbound train times",
            duration: "Duration",
            departure: {
                location: "",
                time: "Departure"
            },
            arrival: {
                location: "Destination station",
                time: "Arrival"
            }
        },
        inboundTrip: {
            title: "Inbound train times",
            duration: "Duration",
            departure: {
                location: "",
                time: "Departure"
            },
            arrival: {
                location: "",
                time: "Arrival"
            }
        },
        operators: "Operator",
        duration: "Journey duration"
    },
    stationsNames: {
        STP: "London St Pancras",
        EBB: "Ebbsfleet International",
        AFI: "Ashford International",
        CMF: "Chambéry-Savoie",
        XAP: "Aime La Plagne",
        XBM: "Bourg St Maurice",
        XBMA: "Bourg St Maurice",
        XAV: "Albertville",
        XMO: "Moutiers",
        XDB: "Lille Europe",
        PLY: "Paris - Gare de Lyon",
        PEST: "Paris - Gare de l'Est",
        AMS: "Amsterdam Centraal",
        RTM: "Rotterdam Centraal",
        ANR: "Antwerp",
        BRU: "Brussels Midi",
        "Bourg-Saint-Maurice": "Bourg Saint Maurice",
        "Aime-la-Plagne": "Aime la Plagne",
        "Moûtiers": "Moûtiers",
    },
    operatorsNames: {
        ES: "Eurostar",
        "9F": "Eurostar",
        PEG: "Pegasus Train"
    },
    trainClass: {
        standard: "Eurostar Standard",
        premium: "Eurostar Plus",
        title: "Travel classes",
        outOfStock: "Out of stock"
    }
};

export default trainUkTranslations;
